var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66659 4H6.99992V0H2.99992V4H0.333252L4.99992 8.66667L9.66659 4ZM0.333252 10V11.3333H9.66659V10H0.333252Z",
    fill: "#0F82ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.f191134f9b31726472a3aedaa4d97243.svg";
export { ForwardRef as ReactComponent };